import AOS from 'aos'

window.AOS = AOS
AOS.init({

})



// WEBPACK FOOTER //
// ./src/js/components/js-component/animate.js